/* eslint-disable react/no-array-index-key */
/* eslint-disable react/no-children-prop */
import { StaticImage } from 'gatsby-plugin-image'
import React from 'react'

import { CarouselComponent } from '../../components'
import JustifiedLinkCard from '../../components/ContentCardComponent/JustifiedLinkCard'
import { useBlogData } from '../../hooks/useBlogPostData'
import useMediaQuery from '../../hooks/useMediaQuery'
import SectionLayout from '../../layouts/SectionLayout/SectionLayout'
import { defaultLanguage } from '../../utils/appConfig'
import {
  bacgroundImage,
  blogCard,
  containerStyling,
  contentCardsContainer,
  contentExtraStyling,
  ctaExtraStyling,
  extraBtnClassName,
  headerStyling,
} from './LatestBlogs.module.css'

const LatestBlogs = ({ lang, slice }) => {
  const blogs = useBlogData().filter((blog) => blog.language.slug === lang)
  const isDesktop = useMediaQuery('(min-width: 867px)')
  const blogpostsData = slice?.relatedpages?.nodes || blogs
  if (!blogpostsData.length) {
    return null
  }
  const heading =
    lang === defaultLanguage.slice(0, 2)
      ? 'Ontdek Meer: Deskundige Inzichten en Verhalen'
      : 'Discover More: Expert Insights and Stories'
  const blogContent = blogpostsData.map((blog, index) => {
    const link =
      blog.pageType?.taxonomy && blog.pageType?.taxonomy === 'treatment'
        ? blog.pageType.uri
        : `blog/${blog.slug}`
    const blogUrl =
      lang === defaultLanguage.slice(0, 2) ? `/${link}/` : `/${lang}/${link}/`
    const ctaBTn = `{"title":"Read more","url":"/","target":"${blogUrl}","dest":"internal","type":"transparent"}`
    return (
      <JustifiedLinkCard
        key={index}
        blogImage={blog.herocontent.herocontentimage}
        content={blog.seo.metaDesc}
        cta={ctaBTn}
        extraClassName={blogCard}
        kicker={blog?.date?.slice(0, 10)}
        title={blog.title}
        url
        urlTarget={`${blogUrl}`}
      />
    )
  })

  const content = isDesktop ? (
    blogContent
  ) : (
    <CarouselComponent children={blogContent} isDesktop={isDesktop} />
  )
  return (
    <SectionLayout
      cta=""
      ctaColumn
      ctaExtraClassName={ctaExtraStyling}
      extraBtnClassName={extraBtnClassName}
      extraDescriptionClassName={contentExtraStyling}
      extraHeaderClassName={containerStyling}
      extraHeadingContainerClassName={headerStyling}
      heading={heading}
      kicker=""
      withCta
      withHeader
    >
      <div className={contentCardsContainer}>{content}</div>
      <StaticImage
        alt="background"
        className={bacgroundImage}
        formats={['auto', 'webp']}
        loading="eager"
        placeholder="none"
        quality="100"
        src="../../assets/images/blogBg.png"
      />
    </SectionLayout>
  )
}

export default LatestBlogs
